import { render, staticRenderFns } from "./ReviewCustomerDetails.vue?vue&type=template&id=9b71ec52&"
import script from "./ReviewCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewCustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCustomerDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b71ec52')) {
      api.createRecord('9b71ec52', component.options)
    } else {
      api.reload('9b71ec52', component.options)
    }
    module.hot.accept("./ReviewCustomerDetails.vue?vue&type=template&id=9b71ec52&", function () {
      api.rerender('9b71ec52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReviewCustomerDetails.vue"
export default component.exports